/*------------------------------------------------*/
/* LIBRARIES
/*------------------------------------------------*/
import React from 'react';
import PropTypes from 'prop-types';
/*------------------------------------------------*/
/* INTERNAL DEPENDENCIES
/*------------------------------------------------*/
import OlListWrapper from './OlList.style';

const OlList = (props) => {
  const {
    items,
  } = props;

  return (
    <OlListWrapper>
      {items.map((item, index) => (
        <div key={item.key} className="row-wrapper">
          <span className="number-content">{index + 1}</span>
          <span className="text-content">{item}</span>
        </div>
      ))}
    </OlListWrapper>
  );
};

/*------------------------------------------------*/
/* PROP TYPES
/*------------------------------------------------*/
OlList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.element
  ).isRequired
};

/*------------------------------------------------*/
/* EXPORTS
/*------------------------------------------------*/
export default OlList;
